import React, { Component } from 'react'
import PropTypes from "prop-types"
import classNames from 'classnames'
import NextBoxFBAHeader from "./NextBoxFBAHeader";
import ListBoxItems from "./ListBoxItems"
import BoxItemStatistics from "./BoxItemStatistics"
import IncompleteOrdersWarning from "./IncompleteOrdersWarning"
import ReopenBox from "./ReopenBox"
import CloseBox from '../../NextBox/components/CloseBox';


class NextBoxFBADetail extends Component {
    state = {
        showDeleteFBA : false
    }

    handleCheckDeleteFBA = (value) => {
        this.setState({
            showDeleteFBA: value
        })
    }

    // Nhân viên thường bị chặn cứng, quản lý fac_admin chỉ phải xác nhận lại.
    // Dùng isAdmin (role thật) chứ KHÔNG dùng isPrivate — isPrivate chỉ là query
    // string ?pass=admin nên ai cũng gõ được.
    _parseCloseGuardFBA = () => {
        // Mặc định true: nếu prop bị quên không truyền thì fail-open (giống GAP-04)
        // chứ không để thùng bị chặn vĩnh viễn không đóng được.
        const { incompleteOrders, incompleteOrdersLoaded = true, isAdmin, box } = this.props
        const vOrders = Array.isArray(incompleteOrders) ? incompleteOrders : []
        const { status } = box

        // Chưa biết thùng có đơn nào chưa đóng đủ hay không -> chặn tạm cho an toàn.
        // NextBoxFBADetail mount ngay khi getBoxDetail xong, trong khi getListBoxItems
        // (call nặng hơn) thường về sau -> nếu để nút mở trong cửa sổ đó thì nhân viên
        // bấm được đúng cái mà feature này sinh ra để ngăn.
        if (!incompleteOrdersLoaded) {
            return {
                blockedReason: 'Đang kiểm tra các đơn chưa đóng đủ, vui lòng đợi...',
                confirmWarning: '',
                warningHint: '',
                warningText: '',
            }
        }

        if (!vOrders.length) {
            return {
                blockedReason: '',
                confirmWarning: '',
                warningHint: '',
                warningText: '',
            }
        }

        const totalUnpacked = vOrders.reduce((total, order) => total + order.unpacked, 0)
        const summary = `còn ${vOrders.length} đơn chưa đóng đủ (${totalUnpacked} sản phẩm chưa tích vào thùng nào)`

        const isClosedFBA = status !== 'opening'

        return {
            blockedReason: isAdmin ? '' : `Không thể đóng thùng: ${summary}.`,
            confirmWarning: isAdmin ? `Thùng này ${summary}.` : '',
            // warningHint -> tooltip (thùng đang mở: nút đóng thùng + tooltip của nó vẫn
            // là kênh giải thích song song nên ẩn sau icon là chấp nhận được)
            warningHint: isClosedFBA
                ? ''
                : (isAdmin
                    ? 'Chỉ có admin mới được phép đóng thùng — hệ thống sẽ yêu cầu xác nhận lại.'
                    : 'Chưa thể đóng thùng cho tới khi xử lý xong.'),
            // warningText -> hiện thẳng. Thùng đã chốt/đã ship thì CloseBox return null:
            // không nút, không tooltip nút, không modal -> đây là kênh DUY NHẤT, không ẩn được.
            warningText: isClosedFBA
                ? 'Thùng này đã được chốt trong khi vẫn còn đơn chưa đóng đủ.'
                : '',
        }
    }

    render() {
        const { box, items, incompleteOrders, onClose, onRefresh, isPrivate, indexBoxClosed, onUpdateLocalStore, barcodeError, loading, isAdmin } = this.props
        const { status } = box
        const {showDeleteFBA} = this.state
        const vIncompleteOrders = Array.isArray(incompleteOrders) ? incompleteOrders : []
        const { blockedReason, confirmWarning, warningHint, warningText } = this._parseCloseGuardFBA()

        return (
            <div className={classNames("NextBoxDetail", status)}>
                <div className="card">
                    <NextBoxFBAHeader
                        box={box}
                        indexBoxClosed={indexBoxClosed}
                        items={items}
                        onUpdateLocalStore={onUpdateLocalStore}
                        onRefresh={onRefresh}
                        barcodeError={barcodeError}
                        onClose={onClose}
                        closeBlockedReason={blockedReason}
                        closeConfirmWarning={confirmWarning}
                    />
                    <IncompleteOrdersWarning orders={vIncompleteOrders} hint={warningHint} alertText={warningText} />
                    <BoxItemStatistics items={items} />
                    <ListBoxItems
                        onRefresh={onRefresh}
                        isPrivate={isPrivate}
                        items={items} box={box}
                        loading={loading}
                        isAdmin={isAdmin}
                        showDelete={showDeleteFBA}
                        handleCheckDelete={this.handleCheckDeleteFBA}
                        incompleteOrders={vIncompleteOrders}
                    />
                    <CloseBox
                        barcodeError={barcodeError}
                        onClose={onClose}
                        box={box}
                        position='footer'
                        disabledReason={blockedReason}
                        confirmWarning={confirmWarning}
                    />
                    <ReopenBox onRefresh={onRefresh} isPrivate={isPrivate} box={box} />
                </div>
            </div>
        )
    }
}

NextBoxFBADetail.propTypes = {
    isPrivate: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    incompleteOrders: PropTypes.array,
    incompleteOrdersLoaded: PropTypes.bool,
    box: PropTypes.object.isRequired,
    onRefresh: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default NextBoxFBADetail
